module.exports = __webpack_public_path__ + "static/img/06053C_X_01_20170621_LC.e6f75bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/06053C_X_01_20170621_LC.png
// module id = ATyK
// module chunks = 0